(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pilpoil-pdp-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-pdp-compare')) {
  customElements.define('pp-pdp-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      const frame = this.querySelector('[data-compare-frame]');
      const range = this.querySelector('.pp-compare__range');
      if (!frame || !range) return;

      const applyValue = (value) => {
        const clamped = Math.max(0, Math.min(100, Number(value)));
        range.value = Math.round(clamped);
        this.style.setProperty('--position', clamped + '%');
      };

      const applyPointer = (event) => {
        const rect = frame.getBoundingClientRect();
        if (!rect.width) return;
        applyValue(((event.clientX - rect.left) / rect.width) * 100);
      };

      range.addEventListener('input', () => applyValue(range.value));

      let dragging = false;

      frame.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragging = true;
        if (frame.setPointerCapture) {
          try { frame.setPointerCapture(event.pointerId); } catch (_) {}
        }
        applyPointer(event);
      });

      frame.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        applyPointer(event);
      });

      const stopDragging = (event) => {
        dragging = false;
        if (frame.hasPointerCapture && frame.hasPointerCapture(event.pointerId)) {
          try { frame.releasePointerCapture(event.pointerId); } catch (_) {}
        }
      };

      frame.addEventListener('pointerup', stopDragging);
      frame.addEventListener('pointercancel', stopDragging);
      frame.addEventListener('lostpointercapture', () => { dragging = false; });

      applyValue(range.value);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pilpoil-pdp-v2-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-pdp-compare')) {
  customElements.define('pp-pdp-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      const frame = this.querySelector('[data-compare-frame]');
      const range = this.querySelector('.pp-compare__range');
      if (!frame || !range) return;

      const applyValue = (value) => {
        const clamped = Math.max(0, Math.min(100, Number(value)));
        range.value = Math.round(clamped);
        this.style.setProperty('--position', clamped + '%');
      };

      const applyPointer = (event) => {
        const rect = frame.getBoundingClientRect();
        if (!rect.width) return;
        applyValue(((event.clientX - rect.left) / rect.width) * 100);
      };

      range.addEventListener('input', () => applyValue(range.value));

      let dragging = false;

      frame.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragging = true;
        if (frame.setPointerCapture) {
          try { frame.setPointerCapture(event.pointerId); } catch (_) {}
        }
        applyPointer(event);
      });

      frame.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        applyPointer(event);
      });

      const stopDragging = (event) => {
        dragging = false;
        if (frame.hasPointerCapture && frame.hasPointerCapture(event.pointerId)) {
          try { frame.releasePointerCapture(event.pointerId); } catch (_) {}
        }
      };

      frame.addEventListener('pointerup', stopDragging);
      frame.addEventListener('pointercancel', stopDragging);
      frame.addEventListener('lostpointercapture', () => { dragging = false; });

      applyValue(range.value);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pilpoil-pdp-v2-video-demo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-video-demo')) customElements.define('pp-video-demo',class extends HTMLElement {
 connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',event=>{const button=event.target.closest('button[data-video]');if(!button)return;const template=button.dataset.video==='primary'?this.querySelector('template[data-primary]'):Array.from(this.querySelectorAll('template[data-video-template]')).find(t=>t.dataset.videoTemplate===button.dataset.video);if(!template)return;const stage=this.querySelector('.pp-video-demo__stage');stage.querySelectorAll('video').forEach(video=>video.pause());stage.replaceChildren(template.content.cloneNode(true));this.querySelectorAll('button[data-video]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});}
 disconnectedCallback(){this.querySelectorAll('video').forEach(video=>video.pause());}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pilpoil-pdp-v2"]) return;
  try {
    
function ppRefreshDuoBadge(root) {
  root.querySelectorAll('variant-picker').forEach(picker => {
    let badge = picker.querySelector('.pp-duo-badge');
    if (!badge) { badge = document.createElement('span'); badge.className = 'pp-duo-badge'; badge.textContent = 'DUO COMPLET'; picker.append(badge); }
    const selected = Array.from(picker.querySelectorAll('input:checked')).map(input => input.value).join(' ').toLowerCase();
    badge.hidden = !(selected.includes('s') && selected.includes('l') && (selected.includes('combo') || selected.includes('duo') || selected.includes('+')));
  });
}
document.addEventListener('change', event => { const root = event.target.closest('.pilpoil-pdp'); if (root) ppRefreshDuoBadge(root); });
document.addEventListener('shopify:section:load', event => ppRefreshDuoBadge(event.target));
document.querySelectorAll('.pilpoil-pdp').forEach(root => { ppRefreshDuoBadge(root); new MutationObserver(() => { if (!root.querySelector('variant-picker .pp-duo-badge')) ppRefreshDuoBadge(root); }).observe(root, {childList:true,subtree:true}); });

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#pilpoil-buy"]');
  if (link && link.hasAttribute('data-pp-choose-duo')) {
    const option = Array.from(document.querySelectorAll('.pilpoil-pdp variant-picker input')).find(input => /combo|duo/i.test(input.value) && /s\s*\+\s*l/i.test(input.value) && !input.disabled);
    if (option && !option.checked) option.click();
  }
  if (!link) return;
  const target = document.querySelector('.pilpoil-pdp variant-picker') || document.querySelector('.pilpoil-pdp product-form-component');
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({behavior: 'auto', block: 'center'});
  const control = target.querySelector('input:not([type="hidden"]):not(:disabled), select, button:not(:disabled)');
  if (control) control.focus({preventScroll: true});
});

function ppEnsureVisibleBrushVariant(root) {
  if (!root) return;
  const picker = root.querySelector('variant-picker');
  if (!picker) return;
  const checked = picker.querySelector('input[type="radio"]:checked');
  if (checked) return;
  const firstVisible = Array.from(picker.querySelectorAll('input[type="radio"]:not(:disabled)')).find((input) => !/XL/i.test(input.value));
  if (firstVisible) firstVisible.click();
}
document.querySelectorAll('.pilpoil-pdp').forEach((root) => requestAnimationFrame(() => ppEnsureVisibleBrushVariant(root)));

function ppInitFeatureCarousel(scope = document) {
  scope.querySelectorAll('.pp-product-features').forEach((section) => {
    if (section.dataset.ppCarouselReady === 'true') return;
    const track = section.querySelector('.pp-product-features__grid');
    const cards = Array.from(section.querySelectorAll('.pp-product-feature'));
    const dots = Array.from(section.querySelectorAll('.pp-product-features__dots span'));
    if (!track || cards.length < 2) return;

    section.dataset.ppCarouselReady = 'true';

    const getIndex = () => {
      const left = track.scrollLeft;
      let best = 0;
      let bestDistance = Infinity;
      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - track.offsetLeft - left);
        if (distance < bestDistance) { bestDistance = distance; best = index; }
      });
      return best;
    };

    const update = () => {
      const active = getIndex();
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    };
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    update();
  });
}
ppInitFeatureCarousel();
document.addEventListener('shopify:section:load', (event) => ppInitFeatureCarousel(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pilpoil-pdp-video-demo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-video-demo')) customElements.define('pp-video-demo',class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.addEventListener('click',event=>{const button=event.target.closest('button[data-video]');if(!button)return;const template=button.dataset.video==='primary'?this.querySelector('template[data-primary]'):Array.from(this.querySelectorAll('template[data-video-template]')).find(t=>t.dataset.videoTemplate===button.dataset.video);if(!template)return;const stage=this.querySelector('.pp-video-demo__stage');stage.querySelectorAll('video').forEach(video=>video.pause());stage.replaceChildren(template.content.cloneNode(true));this.querySelectorAll('button[data-video]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});
  /* Clic / tap sur l'affiche (image + bouton play dessiné) = lancer la vidéo, même si le navigateur ne le fait pas nativement */
  let wasPaused=null;
  this.addEventListener('pointerdown',e=>{const v=e.target.closest('.pp-video-demo__stage video');wasPaused=v?v.paused:null;},true);
  this.addEventListener('click',e=>{const v=e.target.closest('.pp-video-demo__stage video');if(!v||wasPaused!==true)return;setTimeout(()=>{if(v.paused){const p=v.play();if(p&&p.catch)p.catch(()=>{});}},80);});
  /* Au premier lancement : son activé, et la pastille « Son recommandé » disparaît */
  this.addEventListener('play',e=>{const v=e.target;if(!v||v.tagName!=='VIDEO')return;v.muted=false;const s=v.closest('.pp-video-demo__stage');if(s)s.classList.add('is-played');},true);
 }
 disconnectedCallback(){this.querySelectorAll('video').forEach(video=>video.pause());}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pilpoil-pdp"]) return;
  try {
    
function ppRefreshDuoBadge(root) {
  root.querySelectorAll('variant-picker').forEach(picker => {
    let badge = picker.querySelector('.pp-duo-badge');
    if (!badge) { badge = document.createElement('span'); badge.className = 'pp-duo-badge'; badge.textContent = 'DUO COMPLET'; picker.append(badge); }
    const selected = Array.from(picker.querySelectorAll('input:checked')).map(input => input.value).join(' ').toLowerCase();
    badge.hidden = !(selected.includes('s') && selected.includes('l') && (selected.includes('combo') || selected.includes('duo') || selected.includes('+')));
  });
}
document.addEventListener('change', event => { const root = event.target.closest('.pilpoil-pdp'); if (root) ppRefreshDuoBadge(root); });
document.addEventListener('shopify:section:load', event => ppRefreshDuoBadge(event.target));
document.querySelectorAll('.pilpoil-pdp').forEach(root => { ppRefreshDuoBadge(root); new MutationObserver(() => { if (!root.querySelector('variant-picker .pp-duo-badge')) ppRefreshDuoBadge(root); }).observe(root, {childList:true,subtree:true}); });

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#pilpoil-buy"]');
  if (link && link.hasAttribute('data-pp-choose-duo')) {
    const option = Array.from(document.querySelectorAll('.pilpoil-pdp variant-picker input')).find(input => /combo|duo/i.test(input.value) && /s\s*\+\s*l/i.test(input.value) && !input.disabled);
    if (option && !option.checked) option.click();
  }
  if (!link) return;
  const target = document.querySelector('.pilpoil-pdp variant-picker') || document.querySelector('.pilpoil-pdp product-form-component');
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({behavior: 'auto', block: 'center'});
  const control = target.querySelector('input:not([type="hidden"]):not(:disabled), select, button:not(:disabled)');
  if (control) control.focus({preventScroll: true});
});

function ppEnsureVisibleBrushVariant(root) {
  if (!root) return;
  const picker = root.querySelector('variant-picker');
  if (!picker) return;
  const checked = picker.querySelector('input[type="radio"]:checked');
  if (checked) return;
  const firstVisible = Array.from(picker.querySelectorAll('input[type="radio"]:not(:disabled)')).find((input) => !/XL/i.test(input.value));
  if (firstVisible) firstVisible.click();
}
document.querySelectorAll('.pilpoil-pdp').forEach((root) => requestAnimationFrame(() => ppEnsureVisibleBrushVariant(root)));

function ppInitFeatureCarousel(scope = document) {
  scope.querySelectorAll('.pp-product-features').forEach((section) => {
    if (section.dataset.ppCarouselReady === 'true') return;
    const track = section.querySelector('.pp-product-features__grid');
    const cards = Array.from(section.querySelectorAll('.pp-product-feature'));
    const dots = Array.from(section.querySelectorAll('.pp-product-features__dots span'));
    if (!track || cards.length < 2) return;

    section.dataset.ppCarouselReady = 'true';

    const getIndex = () => {
      const left = track.scrollLeft;
      let best = 0;
      let bestDistance = Infinity;
      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - track.offsetLeft - left);
        if (distance < bestDistance) { bestDistance = distance; best = index; }
      });
      return best;
    };

    const update = () => {
      const active = getIndex();
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    };
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    update();
  });
}
ppInitFeatureCarousel();
document.addEventListener('shopify:section:load', (event) => ppInitFeatureCarousel(event.target));

  } catch(e) { console.error(e); }
})();
})();
